import React from 'react'
import { Helmet } from 'react-helmet-async'
import { GridItem } from '@which/seatbelt'

import type { SubVerticalPolicyAndInsightLandingQuery } from '../../../../generated/frontend'
import { PIHeader } from '../../../../shared/components/PolicyAndInsight/PIHeader/PIHeader'
import { PILandingPageSections } from './components/PILandingPageSections'

export const getSubVerticalPolicyAndInsightLandingComponents = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  data: SubVerticalPolicyAndInsightLandingQuery['subVerticalPage']
) => {
  let { contentItems = [] } = data.policyAndInsightLandingCollection ?? {}
  const { meta } = data.policyAndInsightLandingCollection ?? {}
  contentItems = contentItems.filter((n) => n)

  return {
    VerticalHeader: () => (
      <GridItem span={{ medium: 10, large: 10 }} columnStart={{ medium: 2, large: 2 }}>
        <PIHeader {...data.breadcrumb} />
      </GridItem>
    ),
    PILandingCollection: () => (
      <>
        {meta?.title && (
          <Helmet title={meta.title}>
            <meta name="title" content={meta.title} />
            <meta property="og:title" content={meta.title} />
            <meta property="twitter:title" content={meta.title} />
          </Helmet>
        )}
        {meta?.description && (
          <Helmet>
            <meta name="description" content={meta.description} />
            <meta property="og:description" content={meta.description} />
            <meta property="twitter:description" content={meta.description} />
          </Helmet>
        )}
        {meta?.image && (
          <Helmet>
            <meta property="og:image" content={meta.image}></meta>
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:image" content={meta.image} />
          </Helmet>
        )}
        <PILandingPageSections contentItems={contentItems} />
      </>
    ),
  }
}
